// removed by extract-text-webpack-plugin
module.exports = {"header":"KioskHeader__header___1T_6g","name-image":"KioskHeader__name-image___2wR--","name":"KioskHeader__name___1NlRS"};